export const googleApiKey = 'AIzaSyDQ90b6zBbkozSHwN88U_qkKQpI_A4wHYk'

export const stripePublishableKey =
  'pk_test_51P3sj4P6EnLjtBoY0yMxm83W3uAkpXDYehtHRl4rQHuUmj149yH0clBa1DExP6TgZaqsmprbHpdsZA15qDam052u00yabivblA'

export const payKeeperUrl = 'https://app-dev.paykeeper.com'
